import React, { Suspense, lazy, useEffect, useRef, useState } from "react";

import "./LazyLoadComponent.scss";

const lazyWithPreload = (factory) => {
    const Component = lazy(factory);
    Component.preload = factory;
    return Component;
};

const LazyLoadComponent = ({componentName, spinner, height = '1013px'}) => {
    
    const clonedSpinner = React.cloneElement(spinner, {
        className: `${spinner.props.className || ''} lazy-load-component--loader`
      });
    const Component = lazyWithPreload(() => import(`../${firstLetterToLowerCase(componentName)}/${capitalizeFirstLetter(componentName)}`));

    const [ loadComponent, setLoadComponent ] = useState(false);
    const [ showComponent, setShowComponent ] = useState(false);

    const ref = useRef(null);

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
      
      function firstLetterToLowerCase(str) {
        if (!str) return '';
        return str.charAt(0).toLowerCase() + str.slice(1);
      }
    
    useEffect(() => {

        if(!loadComponent) return;

        Component.preload().then(() => {
            setTimeout(() => setShowComponent(true), 100);
        });

    }, [loadComponent])
    
    useEffect(() => {

        const observer = new IntersectionObserver(
            ([entry]) => {
                if(entry.isIntersecting) {
                    setLoadComponent(true);
                }
            },
            {
              threshold: 0.7,
            }
          );
      
          if (ref.current) {
            observer.observe(ref.current);
          }
      
          return () => {
            if (ref.current) observer.unobserve(ref.current);
          };
    }, []);

    return (
        <section className="lazy-load-component" ref={ref} style={{'--height': height}}>
            {clonedSpinner}
            
            {loadComponent && (
                <Suspense>
                    <div className={`component__wrapper ${showComponent ? 'show' : ''}`}>
                        <Component showAdultTeeth={true} show={showComponent} />
                    </div>
                </Suspense>
            )}
        </section>
    );
};

export default LazyLoadComponent;
